
import React, { useState, useEffect } from 'react';
import { 
  Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Button, FormControl, InputLabel, Select,Menu, MenuItem, Box, TextField, Dialog, 
  DialogTitle, DialogContent, DialogActions, CircularProgress, Snackbar, Alert, IconButton, 
  useMediaQuery, Popover,
  Badge,
  Chip,Skeleton
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import TablePagination from '@mui/material/TablePagination';
import DeleteIcon from '@mui/icons-material/Delete';
import api, { getDeviceQRCode } from '../api';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import DeleteButton from '../customcomponents/CustomDeleteButton';
import EditButton from '../customcomponents/CustomEditButton';
import SearchInput from '../customcomponents/CustomSearchInput';
import SelectInput from '../customcomponents/CustomSelectInput';
import PillComponent from '../customcomponents/CustomPillComponent';
import { useSocket } from '../contexts/SocketContext';



export default function DeviceManagementPage() {
  const [status, setStatus] = useState('All');
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const openPopover = Boolean(searchAnchorEl);
  const [devices, setDevices] = useState([]); // Initialize as empty array
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [qrDialogOpen, setQrDialogOpen] = useState(false);
  const [qrCodeData, setQrCodeData] = useState('');
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [deleteLoading, setDeleteLoading] = useState(false);
  const theme = useTheme();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deviceToDelete, setDeviceToDelete] = useState(null);
  const [deviceIdToAssign, setDeviceIdToAssign] = useState(null);

  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [users, setUsers] = useState([]); // For user dropdown
  const [userError, setUserError] = useState('');
  const [reLoadStatus, setreLoadStatus] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width:800px)');
  const socket = useSocket();

  // Fetch users for dropdown
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await api.get('/users');
        if (res.data && res.data.success && Array.isArray(res.data.data)) {
          setUsers(res.data.data.map(user => ({
            id: user.id,
            name: user.name
          })));
        } else {
          setUsers([]);
        }
      } catch (err) {
        setUsers([]);
      }
    };
    fetchUsers();
  }, []);
  
  useEffect(() => {
    if (socket) {
      const handleDeviceLinked = (device) => {
        setQrDialogOpen(false);
        setSnackbar({ open: true, message: device.TA_Device_ID + ' Device linked successfully', severity: 'success' });
        setOpen(false);
        setreLoadStatus((prev) => !prev);
      };

      const handleDeviceStatusUpdate = (device) => {
        setSnackbar({ open: true, message: device.TA_Device_ID + ' Device status updated successfully', severity: 'success' });
        setreLoadStatus((prev) => !prev);
      };

      socket.on('device_linked', handleDeviceLinked);
      socket.on('device_status_update', handleDeviceStatusUpdate);

      return () => {
        socket.off('device_linked', handleDeviceLinked);
        socket.off('device_status_update', handleDeviceStatusUpdate);
      };
    }
  }, [socket]);

  const handleAssignUser = (deviceId) => {
    setDeviceIdToAssign(deviceId);
    setOpen(true);
  };



  const handleSubmit = async () => {
    if (!inputValue) {
      setUserError('User name is required');
      setUsers([]);
      return;
    }
    setUserError('');
    const selectedUser = users.find(u => u.id === inputValue);
    const userName = selectedUser ? selectedUser.name : '';
    const userId = selectedUser ? selectedUser.id : '';
    if (!deviceIdToAssign) {
      setSnackbar({ open: true, message: 'No device selected', severity: 'error' });
      return;
    }
    try {
      // Store the user name in TA_Assigned_User_Name for the device using the dedicated PATCH endpoint
      await api.patch(`/devices/${deviceIdToAssign}/assign-user`, { assignedUserName: userName, assignedUserId: userId });
      setSnackbar({ open: true, message: 'User assigned successfully', severity: 'success' });
      setUsers([]);
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to assign user', severity: 'error' });
      setUsers([]);
    }
    setOpen(false);
    setInterval(() => {
      window.location.reload();
    }, 700);
    setDeviceIdToAssign(null);
    setUsers([]);
  };

    // Edit user assignment: open dialog and prefill with current assigned user
  const handleEditUser = (deviceId) => {
    const device = devices.find(d => d.id === deviceId);
    if (device && device.TA_Assigned_User_Name) {
      const user = users.find(u => u.name === device.TA_Assigned_User_Name);
      setInputValue(user ? user.id : '');
    } else {
      setInputValue('');
    }
    setDeviceIdToAssign(deviceId);
    setOpen(true);
  };

  
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = (value) => {
    setStatus(value);
    handleMenuClose();
  };
    const handleSearchClick = (event) => {
    setSearchAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    // setUsers([]);
    setOpen(false);
    setUserError('');
    setDeviceIdToAssign(null);
    setAnchorEl(null);
    setSearchAnchorEl(null);
    // setSearch('');
  };

  // Fetch devices on component mount
  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const res = await api.get('/devices');
        if (res.data && res.data.success && Array.isArray(res.data.data)) {
          setDevices(res.data.data.map(item => ({
            id: item._id,
            deviceId: item.TA_Device_ID || '-',
            supportNumber: item.TA_Support_Number || '-',
            status: item.TA_Sync_Count,
            // loginTime: item.createdAt ? new Date(item.createdAt).toLocaleString() : '-',
            loginTime: item.updatedAt ? new Date(item.updatedAt).toLocaleString() : '-',
            TA_Assigned_User_Name: item.TA_Assigned_User_Name || '',
            TA_DeviceIsActive: item.TA_DeviceIsActive ? 'Active' : 'Inactive' || '',
            // Add more fields as needed
          })));
        } else {
          setDevices([]);
        }
      } catch (error) {
        console.error('Error fetching devices:', error);
        setSnackbar({ 
          open: true, 
          message: 'Failed to load devices. Please try again later.', 
          severity: 'error' 
        });
      } finally {
        setLoading(false);
      }
    };
    fetchDevices();
  }, [reLoadStatus]);

  const handleLinkDevice = async () => {
    try {
      setLoading(true);
      const response = await getDeviceQRCode();
      console.log('API Response:', response);
      
      if (response && response.success && response.qrCode) {
        console.log('QR Code Data:', response.qrCode);
        setQrCodeData(response.qrCode);
        setQrDialogOpen(true);
      } else {
        throw new Error('Invalid QR code response format');
      }
    } catch (error) {
      console.error('Error loading QR code:', error);
      setSnackbar({ open: true, message: 'Failed to load QR code', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseQrDialog = () => {
    setQrDialogOpen(false);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Ensure we're always working with an array
  const filteredDevices = (Array.isArray(devices) ? devices : []).filter(device => {
    if (!device) return false;
    const searchLower = search.toLowerCase();
    const matchesSearch = (device.deviceId?.toLowerCase().includes(searchLower) ||  device.supportNumber?.toLowerCase().includes(searchLower) || device.TA_DeviceIsActive?.toLowerCase().includes(searchLower));
    const matchesStatus = status === 'All' || device.TA_DeviceIsActive === status;
      console.log(device);
    return matchesSearch && matchesStatus;
  });
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Placeholder handlers for edit and delete
  // const handleDeleteDevice = async (device) => {
  //   if (!window.confirm(`Are you sure you want to delete device ${device.deviceId}?`)) return;
  //   setDeleteLoading(true);
  //   try {
  //     const res = await api.delete(`/devices/${device.id}`);
  //     if (res.data && res.data.success) {
  //       setSnackbar({ open: true, message: 'Device deleted successfully', severity: 'success' });
  //       setDevices((prev) => prev.filter((d) => d.id !== device.id));
  //     } else {
  //       setSnackbar({ open: true, message: 'Failed to delete device', severity: 'error' });
  //     }
  //   } catch (err) {
  //     setSnackbar({ open: true, message: 'Failed to delete device', severity: 'error' });
  //   } finally {
  //     setDeleteLoading(false);
  //   }
  // };

  const handleDeleteDevice = (device) => {
  setDeviceToDelete(device);
  setDeleteDialogOpen(true);
};

const handleDeleteCancel = () => {
  setDeleteDialogOpen(false);
  setDeviceToDelete(null);
};

const handleDeleteConfirm = async () => {
  if (!deviceToDelete) return;

  setDeleteLoading(true);
  try {
    const res = await api.delete(`/devices/${deviceToDelete.id}`);
    if (res.data && res.data.success) {
      setSnackbar({ open: true, message: 'Device deleted successfully', severity: 'success' });
      setDevices((prev) => prev.filter((d) => d.id !== deviceToDelete.id));
    } else {
      setSnackbar({ open: true, message: 'Failed to delete device', severity: 'error' });
    }
  } catch (err) {
    setSnackbar({ open: true, message: 'Failed to delete device', severity: 'error' });
  } finally {
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
    setDeviceToDelete(null);
  }
};


  // Placeholder handler for assigning user
 
  

  return (
    <Box sx={{  background: 'background.default' }}>
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", 
          background:'#FFF',
          boxShadow:'0 2px 12px rgba(0,0,0,0.06)',
          mb: 3,
          gap: 2,
          flexWrap: "wrap", 
          p: { xs: 2, sm: 3 },
          borderRadius:'12px',
        }}
      ></Box> */}
      
      <Paper elevation={0} sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        borderRadius: 3,
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: { xs: 'row', md: 'row' },
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
        position: 'sticky',
        top: isSmallScreen?10:0,
        zIndex: 1000,
      }}>
        {
          isSmallScreen ? (
            <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Devices </Typography>
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Device Management</Typography>
          )
        }
        <Box sx={{display:'flex',flexDirection:{xs:'row',md:'row'},gap:2 ,alignItems:'center'}}>
          {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}> */}
            <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: { xs: 'fit-content', md: 180 } }}
              >
                {isSmallScreen ? (
                  <>
                    <IconButton
                      onClick={handleMenuOpen}
                      color="primary"
                      // sx={{
                      //   bgcolor: theme.palette.primary.main,
                      //   color: theme.palette.primary.contrastText,
                      //   borderRadius: 2, boxShadow: 1,
                      //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
                      //   height: 40, width: 40,
                      // }}
                    >
                      <FilterListIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      {['All', 'Active', 'Inactive'].map((option) => (
                        <MenuItem
                          key={option}
                          selected={status === option}
                          onClick={() => handleStatusChange(option)}
                          sx={{color:'background.text'}}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                ) : (
                  <>
                    <InputLabel>Status</InputLabel>
                    <Select
                      label="Status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <MenuItem value="All">All</MenuItem>
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                  </>
                )}
                </FormControl>
          {/* </Box> */}
          {/* <Box sx={{ display: 'flex' ,alignItems: 'center', gap: 2 , flexDirection:{xs:'column',md:'row'},}}> */}
            {!isSmallScreen && (<SearchInput value={search} onChange={e => setSearch(e.target.value)} />)}
            {isSmallScreen ? (
              <>
              <IconButton
                onClick={handleSearchClick}
                color='primary'
                // sx={{
                //   bgcolor: theme.palette.primary.main,
                //   color: theme.palette.primary.contrastText,
                //   borderRadius: 2, boxShadow: 1,
                //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
                //   height: 40, width: 40,
                // }}
              >
                <SearchIcon />
              </IconButton>
              <Popover open={openPopover} anchorEl={searchAnchorEl} onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
                PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
              >
                <SearchInput value={search} onChange={(e) => setSearch(e.target.value)}  autoFocus />  
              </Popover> 
              <IconButton
                onClick={handleLinkDevice}
                color='primary'
                // sx={{
                //   bgcolor: theme.palette.primary.main,
                //   color: theme.palette.primary.contrastText,
                //   borderRadius: 2, boxShadow: 1, height: 40, width: 40,
                //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2,}, 
                // }}
              >
                <AddIcon />
              </IconButton>
              </>
            ) : (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleLinkDevice}
                  disabled={loading}
                  sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText, fontWeight: 700, borderRadius: 2, boxShadow: 1, fontSize: 15, textTransform: 'none',
                    '&:hover': {
                      bgcolor: theme.palette.primary.dark,
                    },
                    minWidth: {xs:'100%',md:180} 
                  }}
                >
                  {loading ? 'Loading...' : 'Link New Device'}
                </Button>
          )}
          {/* </Box> */}
        </Box>
      </Paper>
      <Box sx={{ mb: 2 }}>
        {/* <Box sx={{ borderBottom: 1, borderColor: '#e0e0e0', mb: 1 }} /> */}
      </Box>
      {
        isSmallScreen ? (
          <>
          {/* Card view for small screens */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {loading ? (
              <>
                {Array.from(new Array(5)).map((_, index) => (
                  <Paper
                    key={index}
                    elevation={2}
                    sx={{
                      borderRadius: 3,
                      boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.5,
                      background: 'background.paper',
                      position: 'relative',
                      m:2,mt:0
                    }}
                  >
                    {/* SL No */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 12,
                        right: 18,
                      }}
                    >
                      <Skeleton variant="text" width={30} height={24} />
                    </Box>

                    {/* Device ID */}
                    <Skeleton variant="text" width="60%" height={32} sx={{ mt: 2 }} />

                    {/* Device details */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1 }}>
                      <Skeleton variant="text" width="80%" height={24} />
                      <Skeleton variant="rectangular" width="50%" height={28} sx={{ borderRadius: 16 }} />
                      <Skeleton variant="rectangular" width="40%" height={28} sx={{ borderRadius: 12 }} />
                      <Skeleton variant="text" width="60%" height={24} />

                      {/* Assign User */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <Skeleton variant="text" width={100} height={24} />
                        <Skeleton variant="circular" width={36} height={36} />
                      </Box>
                    </Box>

                    {/* Actions */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                      <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
                      <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
                    </Box>
                  </Paper>
                ))}
              </>
            ) : filteredDevices.length === 0 ? (
              <Box sx={{ backgroundColor: 'background.default', borderRadius: 2, p: 3, textAlign: 'center' }}>
                <Typography variant="body1" sx={{ color: 'background.text' }}>No devices found</Typography>
              </Box>
            ) : (
              filteredDevices
                .map((device, index) => (
                  <Paper
                    key={device.id}
                    elevation={2}
                    sx={{
                      borderRadius: 3,
                      boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.5,
                      background: 'background.paper',
                      position: 'relative', m:2,mt:0,
                    }}
                  >
                    {/* SL No. at top left */}
                    <Box sx={{
                      position: 'absolute',
                      top: 12,
                      right: 18,
                      color: '#b0b0b0',
                      fontWeight: 700,
                      fontSize: 18,
                      letterSpacing: 1,
                    }}>
                        #{page * rowsPerPage + index + 1}
                    </Box>
                    {/* Device ID as title */}
                    <Typography variant="h6" sx={{ fontWeight: 700, color: 'background.text', mt: 2,fontSize: '1rem', }}>
                      {device.deviceId}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1 }}>
                      <Typography variant="body2" sx={{ color: 'background.text',fontSize: '0.8rem' }}>
                        <strong>Support Number:</strong> {device.supportNumber}
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'background.text',fontSize: '0.8rem' }}>
                        <strong>Device Status:</strong>{' '}
                        {
                          device.TA_DeviceIsActive == 'Active' ? (
                            <Chip label={device.TA_DeviceIsActive} color="success"/>
                          ) : (
                            <Chip label={device.TA_DeviceIsActive} color="error"/>
                          )
                        }
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'background.text',fontSize: '0.8rem' }}>
                        <strong>Link Count:</strong>{' '}
                        <PillComponent status={`${device.status}`} />
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'background.text',fontSize: '0.8rem' }}>
                        <strong>Login Time:</strong> {device.loginTime || 'N/A'}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <Typography sx={{ color: 'background.text',fontWeight: 600,fontSize: '0.8rem' }}>
                          Assign User:
                        </Typography>
                        {device.TA_Assigned_User_Name ? (
                          <Typography fontWeight={600} color="primary.main" sx={{ ml: 1,fontSize: '0.8rem' }}>
                            {device.TA_Assigned_User_Name}
                          </Typography>
                        ) : (
                          <IconButton
                            color="primary"
                            onClick={() => handleAssignUser(device.id)}
                            sx={{ '&:hover': { bgcolor: '#eaf6ff' }, borderRadius: 2, ml: 1 }}
                          >
                            <PersonIcon />
                          </IconButton>
                        )}
                        {/* Assign User Dialog (rendered once for all cards) */}
                        <Dialog open={open} onClose={handleClose} hideBackdrop='true' sx={{maxWidth:550}}>
                          <DialogTitle sx={{color:'background.text'}}>Assign User</DialogTitle>
                          <DialogContent>
                            <FormControl fullWidth margin='dense'>
                              <InputLabel id="user-select-label">User Name</InputLabel>
                              <Select
                                labelId="user-select-label"
                                value={inputValue}
                                label="User Name"
                                onChange={(e) => setInputValue(e.target.value)}
                                autoFocus
                                error={!!userError}
                                sx={{color:'background.text'}}
                              >
                                {users.map((user) => (
                                  <MenuItem key={user.id} value={user.id} sx={{color:'background.text'}}>{user.name}</MenuItem>
                                ))}
                              </Select>
                              {userError && (
                                <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                  {userError}
                                </Typography>
                              )}
                            </FormControl>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose} color="secondary">
                              Cancel
                            </Button>
                            <Button onClick={handleSubmit} color="primary" variant="contained">
                              Submit
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Box>
                    </Box>
                    {/* Actions */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, }}>
                      <Button
                        size="small"
                        startIcon={<EditIcon />}
                        onClick={() => handleEditUser(device.id)}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        color="error"
                        startIcon={<DeleteIcon />}
                        onClick={() => handleDeleteDevice(device)}
                      >
                        Delete
                      </Button>
                    </Box>
                  </Paper>
                ))
            )}
            {/* Pagination for card view */}
            {/* <Box sx={{ px: 2, py: 1, backgroundColor: 'background.default', mt: 2 }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredDevices.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: 'background.default',
                  color: 'background.text',
                  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                    // marginBottom: 0,
                  },
                }}
              />
            </Box> */}
          </Box>
          </>
        ) : (
          <Paper elevation={1} sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', p: 0, overflow: 'auto', mb: 3, }}>
            <TableContainer sx={{ maxHeight: {xs: 400, sm: 500, md: 600,} }}>
              <Table stickyHeader sx={{backgroundColor:'background.paper'}}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>SL No.</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Device ID</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Support Number</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Device Status</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Link Count</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Login Time</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Assign User</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <>
                    {Array.from(new Array(10)).map((_, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:hover': { backgroundColor: 'action.hover' },
                          transition: 'background 0.2s',
                        }}
                      >
                        <TableCell>
                          <Skeleton variant="text" width={20} height={24} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={100} height={24} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={120} height={24} />
                        </TableCell>
                        <TableCell>
                          {/* Chip skeleton */}
                          <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 2 }} />
                        </TableCell>
                        <TableCell>
                          {/* PillComponent skeleton */}
                          <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 12 }} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={100} height={24} />
                        </TableCell>
                        <TableCell>
                          {/* Assign user / icon skeleton */}
                          <Box display="flex" alignItems="center" gap={1}>
                            <Skeleton variant="circular" width={36} height={36} />
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box display="flex" justifyContent="space-evenly">
                            {/* Action buttons skeleton */}
                            <Skeleton variant="circular" width={36} height={36} />
                            <Skeleton variant="circular" width={36} height={36} />
                            <Skeleton variant="circular" width={36} height={36} />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                    </>
                  ) : filteredDevices.length === 0 ? (
                    <TableRow sx={{backgroundColor:'background.default'}}>
                      <TableCell colSpan={8} align="center">
                        <Typography variant="body1" sx={{color:'background.text'}}>No devices found</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredDevices
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((device, index) => (
                        <TableRow key={device.id} sx={{ '&:hover': { backgroundColor: theme.palette.action.hover }, transition: 'background 0.2s',  }}>
                          <TableCell sx={{color:'background.text'}}>{page * rowsPerPage + index + 1}</TableCell>
                          <TableCell sx={{color:'background.text'}}>{device.deviceId}</TableCell>
                          <TableCell sx={{color:'background.text'}}>{device.supportNumber}</TableCell>
                          <TableCell sx={{color:'background.text'}}>
                            {
                              device.TA_DeviceIsActive == 'Active' ? (
                                <Chip label={device.TA_DeviceIsActive} color="success"/>
                              ) : (
                                <Chip label={device.TA_DeviceIsActive} color="error"/>
                              )
                            }
                          </TableCell>
                          <TableCell sx={{color:'background.text'}}>
                            <PillComponent sx={{position:'relative',left:25}} status={`${device.status}`} />
                          </TableCell>
                          <TableCell sx={{color:'background.text'}}>{device.loginTime || 'N/A'}</TableCell>
                          <TableCell>
                            {device.TA_Assigned_User_Name ? (
                              <Typography fontWeight={600} color="primary.main">{device.TA_Assigned_User_Name}</Typography>
                            ) : (
                              <Box display="flex" alignItems="center" gap={1}>
                                <IconButton color="primary" onClick={() => handleAssignUser(device.id)}  sx={{ '&:hover': { bgcolor: '#eaf6ff' }, borderRadius: 2 }}>
                                  <PersonIcon />
                                </IconButton>
                              </Box>
                            )}
                            
                            <Dialog open={open} onClose={handleClose} fullWidth hideBackdrop='true'>
                              <DialogTitle sx={{color:'background.text'}}>Assign User</DialogTitle>
                              <DialogContent>
                                <FormControl fullWidth margin='dense'>
                                  <InputLabel id="user-select-label">User Name</InputLabel>
                                  <Select
                                    labelId="user-select-label"
                                    value={inputValue}
                                    label="User Name"
                                    onChange={(e) => setInputValue(e.target.value)}
                                    autoFocus
                                    error={!!userError}
                                    sx={{color:'background.text'}}
                                  >
                                    {users.map((user) => (
                                      <MenuItem key={user.id} value={user.id} sx={{color:'background.text'}}>{user.name}</MenuItem>
                                    ))}
                                  </Select>
                                  {userError && (
                                    <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                      {userError}
                                    </Typography>
                                  )}
                                </FormControl>
                              </DialogContent>
                              <DialogActions>
                                <Button onClick={handleClose} color="secondary">
                                  Cancel
                                </Button>
                                <Button onClick={handleSubmit} color="primary" variant="contained">
                                  Submit
                                </Button>
                              </DialogActions>
                            </Dialog>

                          </TableCell>
                          <TableCell>
                            <Box display="flex" justifyContent={'space-evenly'}>
                              <DeleteButton onClick={() => handleDeleteDevice(device)} disabled={deleteLoading}/>
                              <EditButton onClick={() => handleEditUser(device.id)} />
                              {/* <IconButton
                                color="error"
                                onClick={() => handleDeleteDevice(device)}
                                disabled={deleteLoading}
                                sx={{ '&:hover': { bgcolor: '#ffeaea' }, borderRadius: 2 }}
                              >
                                <DeleteIcon />
                              </IconButton>

                              <IconButton
                                color="primary"
                                // onClick={() => handleAssignUser(device.id) }
                                onClick={() => handleEditUser(device.id)}
                                sx={{ '&:hover': { bgcolor: '#eaf6ff' }, borderRadius: 2 }}
                              >
                                <EditIcon />
                              </IconButton> */}
                            </Box>
                          </TableCell>

                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ px: 2, py: 1, background: theme.palette.mode === 'dark' ? 'transparent':'#fff' }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredDevices.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                    // marginBottom: 0,
                  },
                  background: theme.palette.mode === 'dark' ? 'transparent':'#fff',
                  color: 'background.text',
                }}
              />
            </Box>
          </Paper>
        )
      }
      {/* QR Code Dialog */}
      <Dialog open={qrDialogOpen} onClose={handleCloseQrDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{color:'background.text'}}>Link Device</DialogTitle>
        <DialogContent sx={{ p: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
          {loading ? (
            <CircularProgress />
          ) : qrCodeData ? (
            <img 
              src={qrCodeData} 
              alt="Device QR Code" 
              style={{ 
                width: '100%', 
                maxWidth: '300px', 
                height: 'auto',
                display: 'block',
                padding: '20px'
              }} 
            />
          ) : (
            <Typography>No QR code available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseQrDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Delete Confirmation Dialog */}
    <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 600, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>
      Delete Device
    </DialogTitle>
    <DialogContent sx={{ bgcolor: 'transparent' }}>
      <Typography sx={{ color: 'background.text' }}>
        Are you sure you want to delete <b>{deviceToDelete?.deviceId}</b>?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleDeleteCancel} sx={{ fontWeight: 600 }} disabled={deleteLoading}>Cancel</Button>
      <Button onClick={handleDeleteConfirm} color="error" variant="contained" sx={{ fontWeight: 600 }} disabled={deleteLoading}>
        {deleteLoading ? 'Deleting...' : 'Delete'}
      </Button>
    </DialogActions>
    </Dialog>


    </Box>
  );
}

